module.exports = __webpack_public_path__ + "img/p12.920d9e3b.png";